<div class="menu_area nav-open">
  <div id="header_area" class="shadow">
    <div class="inner_header_area flex_layout fix_center_large">
      <app-header-nav
        [isOpen]="true"
        (clickMenuButton)="close()"
      ></app-header-nav>
    </div>
  </div>
</div>
